// extracted by mini-css-extract-plugin
export default {"wrap":"vr-z","fullWidth":"wr-z","items":"xr-z","featureCss":"yr-z","disabled":"zr-z","imgCss":"Ar-z"};